import type { ComponentType } from "react";
import { KgArtifactIcon } from "../../atoms/KgArtifactIcon";
import { KgDatabaseIcon } from "../../atoms/KgDatabaseIcon";
import { KgDataStoryIcon } from "../../atoms/KgDataStoryIcon";
import { KgMetricIcon } from "../../atoms/KgMetricIcon";
import { KgOntologyOrbitIcon } from "../../atoms/KgOntologyOrbitIcon";
import { KgCatalogLayersIcon } from "../catalog/kgCatalogSectionIcons";
import { KgPanelTableIcon } from "../../atoms/KgPanelTableIcon";
import { KgReportIcon, type KgReportIconProps } from "../../atoms/KgReportIcon";
import type { KgArtifactIconProps } from "../../atoms/KgArtifactIcon/KgArtifactIcon.types";
import type { KgDatabaseIconProps } from "../../atoms/KgDatabaseIcon/KgDatabaseIcon.types";
import type { KgDataStoryIconProps } from "../../atoms/KgDataStoryIcon/KgDataStoryIcon.types";
import type { KgMetricIconProps } from "../../atoms/KgMetricIcon/KgMetricIcon.types";
import type { KgOntologyOrbitIconProps } from "../../atoms/KgOntologyOrbitIcon/KgOntologyOrbitIcon.types";
import type { KgPanelTableIconProps } from "../../atoms/KgPanelTableIcon/KgPanelTableIcon.types";
import type { KgFlowNodeType } from "./types";

type KgNodeIconProps =
  | KgArtifactIconProps
  | KgDatabaseIconProps
  | KgDataStoryIconProps
  | KgMetricIconProps
  | KgOntologyOrbitIconProps
  | KgPanelTableIconProps
  | KgReportIconProps;

/**
 * Canvas node icons by `KgFlowNodeType` — use for Used in sections and anywhere
 * the UI groups items by downstream node type.
 */
export const kgNodeIcons = {
  dataSource: KgDatabaseIcon,
  schema: KgDatabaseIcon,
  table: KgPanelTableIcon,
  dataModel: KgCatalogLayersIcon,
  ontology: KgOntologyOrbitIcon,
  metric: KgMetricIcon,
  report: KgReportIcon,
  dataStory: KgDataStoryIcon,
  artifact: KgArtifactIcon,
} as const satisfies Record<KgFlowNodeType, ComponentType<KgNodeIconProps>>;

export const KG_NODE_ICON_SIZE = 16;

export const getKgNodeIcon = (
  nodeType: KgFlowNodeType,
): ComponentType<KgNodeIconProps> => kgNodeIcons[nodeType];
